/**
 * cyrb53 (c) 2018 bryc (github.com/bryc)
 * A fast and simple hash function with decent collision resistance.
 * Largely inspired by MurmurHash2/3, but with a focus on speed/simplicity.
 * Public domain. Attribution appreciated.
 * @see https://stackoverflow.com/a/52171480
 * @see https://github.com/bryc/code/blob/516c6942da7a48963d81bda5428d13380ef8da5a/jshash/experimental/cyrb53.js
 *
 */
export const cyrb53 = (value: string, seed = 0): number => {
  let h1 = 0xde_ad_be_ef ^ seed;
  let h2 = 0x41_c6_ce_57 ^ seed;

  for (let index = 0, ch; index < value.length; index++) {
    ch = value.codePointAt(index) ?? 0;
    h1 = Math.imul(h1 ^ ch, 2_654_435_761);
    h2 = Math.imul(h2 ^ ch, 1_597_334_677);
  }

  h1 =
    Math.imul(h1 ^ (h1 >>> 16), 2_246_822_507) ^
    Math.imul(h2 ^ (h2 >>> 13), 3_266_489_909);
  h2 =
    Math.imul(h2 ^ (h2 >>> 16), 2_246_822_507) ^
    Math.imul(h1 ^ (h1 >>> 13), 3_266_489_909);

  return 4_294_967_296 * (2_097_151 & h2) + (h1 >>> 0);
};
